const MS_PER_DAY = 24 * 60 * 60 * 1000;

function formatLocalDate(date) {
    const pad = n => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export default () => ({
    resetFilters() {
        const root = this.$el.getRootNode();
        const today = new Date();
        const df = formatLocalDate(today);
        const dt = formatLocalDate(new Date(today.getTime() + 7 * MS_PER_DAY));

        root.querySelector('[name=dateFrom]').value = df;
        root.querySelector('[name=dateTo]').value = dt;
        root.querySelector('[name=statusGroup]').value = '';

        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('dateFrom', df);
        pageUrl.searchParams.set('dateTo', dt);
        pageUrl.searchParams.delete('statusGroup');
        history.replaceState({}, '', pageUrl);

        htmx.ajax('GET', this.$el.dataset.url + '?dateFrom=' + df + '&dateTo=' + dt, {
            target: root.querySelector('#communicationsTable'),
            swap: 'outerHTML'
        });
    }
});
